var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('edit-button',_vm._b({},'edit-button',_vm.$props,false)),_c('copy-button',{attrs:{"id":_vm.id,"storeModule":_vm.storeModule}}),_c('delete-button',{attrs:{"id":_vm.id,"storeModule":_vm.storeModule}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }